import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  structuredData?: Record<string, any>;
}

export function SEO({ title, description, canonicalUrl, structuredData }: SEOProps) {
  const baseUrl = 'https://online-kalkulator.com';
  const fullUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} data-react-helmet="true" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-react-helmet="true" />
      <meta property="og:url" content={fullUrl} data-react-helmet="true" />
      <meta property="og:title" content={title} data-react-helmet="true" />
      <meta property="og:description" content={description} data-react-helmet="true" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-react-helmet="true" />
      <meta name="twitter:url" content={fullUrl} data-react-helmet="true" />
      <meta name="twitter:title" content={title} data-react-helmet="true" />
      <meta name="twitter:description" content={description} data-react-helmet="true" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} data-react-helmet="true" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}